import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {
  MixedWidget2,
  MixedWidget10,
  MixedWidget11,
  ListsWidget2,
  ListsWidget3,
  ListsWidget4,
  ListsWidget5,
  ListsWidget6,
  TablesWidget10,
  MixedWidget8,
  TilesWidget1,
  TilesWidget4,
  TilesWidget2,
  TilesWidget5,
  TilesWidget3, StatisticsWidget5, ChartsWidget1, ChartsWidget2,
} from '../../../_metronic/partials/widgets'
import React, {useEffect, useState} from "react";
import {GetDashboardReportSectionOne} from "./core/model";
import {SwalClose, SwalError, SwalLoading} from "../../../_metronic/helpers/components/Swal";
import {GetDashboardReportSectionOneApi} from "./core/Request";
import LastDiskComponent from "./LastTimeLine/LastDiskComponent";
import LastLoginComponent from "./LastTimeLine/LastLoginComponent";
import LastRegisterComponent from "./LastTimeLine/LastRegisterComponent";
import LastPayComponent from "./LastTimeLine/LastPayComponent";

const DashboardPage = () => {
  const [sectionOne,setSectionOne] = useState<GetDashboardReportSectionOne>()
  const BindOne =async ()=>{
    try {
      SwalLoading()
      const {data:response} = await GetDashboardReportSectionOneApi()
      setSectionOne(response);
      SwalClose()
    }catch (err:any){
      SwalLoading()
      SwalError(err.response.data.message)
    }
  }
  useEffect(()=>{
    BindOne()
  },[])

  return (
      <>
        {/* begin::Row */}
        <div className='row g-5 g-xl-8'>
          <div className='col-xl-3'>
            <StatisticsWidget5
                className='card-xl-stretch mb-xl-8'
                svgIcon='/media/icons/duotune/general/gen032.svg'
                color='body'
                iconColor='primary'
                titleColor='gray-900'
                descriptionColor='gray-400'
                title={sectionOne?.usersActive.toString() || ''}
                description='کاربر فعال امروز'
            />
          </div>

          <div className='col-xl-3'>
            <StatisticsWidget5
                className='card-xl-stretch mb-xl-8'
                svgIcon='/media/icons/duotune/ecommerce/ecm008.svg'
                color='dark'
                iconColor='gray-100'
                titleColor='gray-100'
                descriptionColor='gray-100'
                title={sectionOne?.usersToDayRegistration.toString() || ''}
                description='کاربر جدید'
            />
          </div>

          <div className='col-xl-3'>
            <StatisticsWidget5
                className='card-xl-stretch mb-xl-8'
                svgIcon='/media/icons/duotune/finance/fin006.svg'
                color='warning'
                iconColor='white'
                title={sectionOne?.toDayValue.toLocaleString()|| ''}
                titleColor='white'
                descriptionColor='white'
                description='فروش امروز'
            />
          </div>

          <div className='col-xl-3'>
            <StatisticsWidget5
                className='card-xl-stretch mb-5 mb-xl-8'
                svgIcon='/media/icons/duotune/graphs/gra007.svg'
                color='info'
                iconColor='white'
                title={sectionOne?.sumValue.toLocaleString()|| ''}
                titleColor='white'
                descriptionColor='white'
                description='فروش این ماه'
            />
          </div>
        </div>
        {/* end::Row */}
        {/* begin::Row */}
        <div className='row g-5 g-xl-8'>
          <div className='col-xxl-4'>
            <LastRegisterComponent className='card-xxl-stretch' />
          </div>
          <div className='col-xl-8'>
            <ChartsWidget1 className='card-xl-stretch mb-xl-8' />
          </div>

        </div>
        {/* end::Row */}
        {/* begin::Row */}
        <div className='row gy-5 g-xl-8'>
          <div className='col-xxl-4'>
            <LastDiskComponent className='card-xxl-stretch' />
          </div>
          <div className='col-xxl-4'>
            <LastLoginComponent className='card-xxl-stretch' />
          </div>
          <div className='col-xl-4'>
            <LastPayComponent className='card-xl-stretch mb-xl-8' />
          </div>
        </div>
        {/* end::Row */}


      </>
  )
}

const DashboardWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
